// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const CameraIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Camera/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4 5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1.586a1 1 0 0 1-.707-.293l-1.121-1.121A2 2 0 0 0 11.172 3H8.829a2 2 0 0 0-1.415.586L6.293 4.707A1 1 0 0 1 5.586 5H4Zm6 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
  clipRule: "evenodd"
}));
export default CameraIcon;